import { NextImage } from '@apeiron/temp'
import { Box, styled, Typography } from '@mui/material'
import ThinPlusSVG from '@public/icons/icon-thin-plus.svg'
import StarCardSVG from '@public/images/image-select-card.jpg'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const Container = styled(Box)`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 30px;
  height: 437px;
  justify-content: center;
  width: 317px;
`

const CardBackground = styled(NextImage)`
  height: 100%;
  position: absolute;
  width: 100%;
`

const IconPlus = styled(NextImage)`
  aspect-ratio: 1;
  width: 60px;
`

const SelectText = styled(Typography)`
  color: white;
  position: relative;
  font-size: 18px;
  font-weight: 300;
  line-height: 18px;
`

const StarSelectCard: FC<Props> = (props: Props) => {
  const { className } = props

  const { t } = useTranslation()

  return (
    <Container className={className}>
      <CardBackground src={StarCardSVG} />
      <IconPlus src={ThinPlusSVG} />
      <SelectText>{t('star.attachment.button.select')}</SelectText>
    </Container>
  )
}

type Props = {
  className?: string
}

export default StarSelectCard
